import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { TableCell } from '@/components/ui/table';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Plus, Eye, Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CompanyFundsRowProps {
  fund: {
    id: string;
    fund_code?: string | null;
    fund_name?: string | null;
    fund_type?: string | null;
    category?: string | null;
  };
  index: number;
  onAddToPortfolio: (fundId: string) => void;
  onWatchlist: (fundId: string) => void;
  onFavorite: (fundId: string) => void;
}

export default function CompanyFundsRow({ fund, index, onAddToPortfolio, onWatchlist, onFavorite }: CompanyFundsRowProps) {
  return (
    <motion.tr
      key={fund.id}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      className={cn(
        'hover:bg-muted/10 transition-colors',
        index % 2 === 0 ? 'bg-background' : 'bg-muted/20'
      )}
    >
      <TableCell className="w-[140px] pl-4 py-4 font-mono whitespace-nowrap">
        {fund.fund_code || '-'}
      </TableCell>
      <TableCell className="w-[40%] pl-4 py-4 font-medium">
        {fund.fund_name || '-'}
      </TableCell>
      <TableCell className="w-[20%] pl-4 py-4">
        {fund.fund_type || '-'}
      </TableCell>
      <TableCell className="w-[30%] pl-4 py-4">
        {fund.category || '-'}
      </TableCell>
      <TableCell className="w-[100px] text-right pr-4 py-4">
        <div className="flex justify-end gap-2">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8"
                  onClick={() => onAddToPortfolio(fund.id)}
                >
                  <Plus className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Add to Portfolio</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8"
                  onClick={() => onWatchlist(fund.id)}
                >
                  <Eye className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Add to Watchlist</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8"
                  onClick={() => onFavorite(fund.id)}
                >
                  <Star className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Favorite</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </TableCell>
    </motion.tr>
  );
}
